import { atom } from 'ximple/atoms';
import { LocalStorageKey, getDynamicStorageKey } from '../localstorage';

// The native member's Passport personal access token (7-day, no refresh).
// Host-namespaced so one tenant's token never leaks into another tenant's
// widget on a shared origin. `null` means logged out.
export const nativeMemberTokenAtom = atom<string | null>({
    initialValue: null,
    persistKey: getDynamicStorageKey(LocalStorageKey.NATIVE_MEMBER_TOKEN),
});
